import { render } from "./RegisteredOnCourse.vue?vue&type=template&id=00ae69b8&scoped=true"
import script from "./RegisteredOnCourse.vue?vue&type=script&lang=js"
export * from "./RegisteredOnCourse.vue?vue&type=script&lang=js"

import "./RegisteredOnCourse.vue?vue&type=style&index=0&id=00ae69b8&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\zsmshlcourses\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ae69b8"]])

export default __exports__